import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { notify } from 'actions';

class Tab extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    if(!this.props.active) {
      return <noscript />
    }

    return (
      <div className={`tab-pane${this.props.active ? ' active' : ''}`}>
        {this.props.children}
      </div>
    )
  }
}

Tab.propTypes = {
  title : PropTypes.string.isRequired,
  active : PropTypes.bool
}

class FormWizardUnconnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab : this.props.tab || 0
    }
    this.handleSelect = this.handleSelect.bind(this)
  }
  handleSelect(e, index) {
    e.preventDefault();
    let should_tab = true;
    if(this.props.shouldTab) {
      should_tab = this.props.shouldTab(index);
    }
    if(should_tab) {
      this.setState({ activeTab : index });
    }
    if(this.props.onTab) {
      this.props.onTab(index);
    }
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.tab != this.state.activeTab) {
      this.setState({ activeTab : nextProps.tab });
    }
  }
  render() {
    let children = [];
    React.Children.forEach(this.props.children, (child, index) => child ? children.push(child) : null);

    children = React.Children.map(children, (child, index) => child ? React.cloneElement(child, {
      active : index == this.state.activeTab
    }) : null);

    return (
      <div className="wizard-tabs mb-none">
        <ul className="wizard-steps">
          {React.Children.map(children, (child, index) => child ? (
            <li className={`${this.state.activeTab == index ? 'active' : ''}`}>
              <a href="#" className="text-center" onClick={e => this.handleSelect(e, index)}>
                <span className="badge hidden-xs">{child.props.badge || index + 1}</span>{' '}
                {child.props.title}
              </a>
            </li>
          ): null)}
        </ul>
        <div className="tab-content">
          {children}
        </div>
      </div>
    )
  }
}

FormWizardUnconnected.propTypes = {
  shouldTab : PropTypes.func,
  onTab : PropTypes.func.isRequired,
}

const FormWizard = connect(null, { notify })(FormWizardUnconnected);
export { Tab, FormWizard as Wizard };



// WEBPACK FOOTER //
// ./src/browser/components/ui/form-wizard.js